/**
 * #769 — the single build-id source of truth, shared by client and server.
 *
 * `__BUILD_ID__` is a compile-time constant textually replaced by Vite's
 * `define` (see vite.config.ts) during the ONE build that produces both the
 * client bundle and the Cloudflare Worker. Because it's the same literal
 * substituted into both, the id the client compares against and the id
 * GET /api/health returns are guaranteed identical for a given deploy — no
 * runtime coordination, no drift.
 *
 * `typeof` guard: in environments where the define didn't run (the vitest
 * Workers pool, `tsc`), `__BUILD_ID__` is simply absent and we fall back to
 * "dev". `typeof <undeclared>` is safe and never throws.
 */

declare const __BUILD_ID__: string;

export const BUILD_ID: string =
  typeof __BUILD_ID__ !== "undefined" && __BUILD_ID__ ? __BUILD_ID__ : "dev";
